/** Playback preference is local and account-scoped, independent of lesson completion. */
export const PLAYBACK_RATES = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] as const;
type RateStorage = Pick<Storage, "getItem" | "setItem">;
const key = (scope: string) => `piggo.learning.playback-rate.v1:${encodeURIComponent(scope)}`;
const valid = (rate: number) => Number.isFinite(rate) && rate >= 0.25 && rate <= 4;

export function readPlaybackRate(scope: string, storage?: RateStorage): number {
  try {
    const rate = Number((storage ?? window.localStorage).getItem(key(scope)));
    return valid(rate) ? rate : 1;
  } catch { return 1; }
}
export function rememberPlaybackRate(scope: string, rate: number, storage?: RateStorage): void {
  if (!valid(rate)) return;
  try { (storage ?? window.localStorage).setItem(key(scope), String(rate)); }
  catch { /* A storage failure must not interrupt the current playback. */ }
}
